import { useForm, useWatch } from "react-hook-form";
import { Link, useLocation } from "react-router-dom";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useRegister } from "../../hooks/use-register";
import { RegisterForm } from "./register-form";
import { PasswordPolicy } from "../password-policy";

const schema = yup
    .object({
        firstName: yup.string().required("Please enter your first name"),
        lastName: yup.string().required("Please enter your last name"),
        email: yup
            .string()
            .email("Invalid email")
            .required("Please enter an email"),
        password: yup
            .string()
            .required("Please enter a password")
            .min(6, "Password should be at least 6 characters"),
        claimType: yup.string().required("Please select a role"),
    })
    .required();

export const RegisterUser = () => {
    const location = useLocation();

    const methods = useForm({
        resolver: yupResolver(schema),
    });

    const password = useWatch({
        control: methods.control,
        name: "password",
    });

    const mutation = useRegister();

    const onSubmit = (data) => {
        mutation.mutate(data);
    };

    return (
        <div className="w-full">
            <div>
                <h1 className="mb-3 text-3xl/6 font-bold">Create an account</h1>
                <p className="mb-3 text-sm">
                    Already have an account?{" "}
                    <Link
                        to="/login"
                        state={location.state}
                        className="no-underline hover:underline"
                    >
                        <strong>Log in</strong>
                    </Link>
                </p>
            </div>
            <RegisterForm
                methods={methods}
                mutation={mutation}
                onSubmit={onSubmit}
            />
            {mutation.error &&
                mutation.error.code ===
                    "auth/password-does-not-meet-requirements" && (
                    <PasswordPolicy password={password} />
                )}
        </div>
    );
};
